import { OverlayPositionBuilder, FlexibleConnectedPositionStrategy } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
export class SidenavMenuPositionStrategy extends FlexibleConnectedPositionStrategy {
    constructor(x, y, z, a, b) {
        super(x, y, z, a, b);
    }
    /**
     * Updates the position of the overlay element, using whichever preferred position relative
     * to the origin best fits on-screen.
     */
    apply() {
        if (this['_pane'] &&
            this['_pane'].firstChild &&
            this['_pane'].firstChild.classList &&
            this['_pane'].firstChild.classList.contains('sidebar-flyout-menu')) {
            this['_offsetX'] = 64;
        }
        super.apply();
    }
    static { this.ɵfac = function SidenavMenuPositionStrategy_Factory(__ngFactoryType__) { i0.ɵɵinvalidFactory(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SidenavMenuPositionStrategy, factory: SidenavMenuPositionStrategy.ɵfac }); }
}
export class ExtendedPositionBuilder extends OverlayPositionBuilder {
    /**
     * Creates a FlexibleConnectedPosition strategy.
     */
    flexibleConnectedTo(elementRef) {
        return new SidenavMenuPositionStrategy(elementRef, this['_viewportRuler'], this['_document'], this['_platform'], this['_overlayContainer']);
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵExtendedPositionBuilder_BaseFactory; return function ExtendedPositionBuilder_Factory(__ngFactoryType__) { return (ɵExtendedPositionBuilder_BaseFactory || (ɵExtendedPositionBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(ExtendedPositionBuilder)))(__ngFactoryType__ || ExtendedPositionBuilder); }; })(); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExtendedPositionBuilder, factory: ExtendedPositionBuilder.ɵfac }); }
}
//# sourceMappingURL=sidenav-menu-position-strategy.js.map